import { toPascal } from "../../utils/helpers";
import { handleResponse } from "src/services/apiServices";
import { trackPromise } from "react-promise-tracker";
import { IShared } from "../interfaces/IShared";
import { createSlice } from "@reduxjs/toolkit";
import { updateStatusAPI } from "src/api/preventiveAppointmentAPI";
import { updateCaseStatusAPI } from "src/api/ateCasesAPI";
import config from "src/config";
import { PopupType } from "src/resources/enum";

export const save = (updateStatusObj: any, onSuccess: any) => {
  return async (dispatch: any, getState: any) => {
    const language = getState().lookup.language;
    const { popupType, caseID, appointmentID, statusId, onHoldReasonID } =
      getState().shared;

    updateStatusObj.caseID = caseID;
    updateStatusObj.appointmentID = appointmentID;
    updateStatusObj.status = statusId;
    updateStatusObj.onHoldReasonID = onHoldReasonID == "00000000-0000-0000-0000-000000000000"
      ? null
      : onHoldReasonID;
    if(!(updateStatusObj.maintenanceReport && updateStatusObj.maintenanceReport?.fileName))
    {
      updateStatusObj.maintenanceReport = null;
    }
    const updateStatus = toPascal(updateStatusObj);
    var api = config.Case.updateStatus;
    if (popupType == PopupType.Appointment) {
      //set onHold Reason as visible
      api = config.appointments.updateStatus;
    }

    trackPromise(
      updateStatusAPI(updateStatus, api)
        .then((res) => {
          onSuccess();
        })
        .catch((err) => {
          handleResponse(err, language);
        })
    );
  };
};

const initialState: IShared = {
  caseID: "",
  appointmentID: "",
  Status: 0,
  bmcFeedback: "",
  onHoldReasonID: "",
  maintenanceReport: {
    fileName: null,
    fileExtension: null,
    fileBase64: null,
    subject: null,
  },
  isUpdateStatusPopupOpen: false,
  selectedId: "",
  popupType: "",
  statusId: 0,
  showHistoricalDataChangeSource:"",
};

const iShared = createSlice({
  name: "iShared",
  initialState,
  reducers: {
    setIsUpdateStatusPopupOpen: (state, action) => {
      state.isUpdateStatusPopupOpen = action.payload;
    },
    setSelectedId: (state, action) => {
      state.caseID = action.payload;
      state.appointmentID = action.payload;
    },
    setOnHoldReason: (state, action) => {
      state.onHoldReasonID = action.payload;
    },
    setPreSelectedStatus: (state, action) => {
      state.statusId = action.payload;
    },
    setPopupType: (state, action) => {
      state.popupType = action.payload;
    },
    setMaintenanceReport: (state, action) => {
      state.maintenanceReport = action.payload;
    },
    setChangeHistoricalDataSource: (state, action) => {
      state.showHistoricalDataChangeSource = action.payload;
    },
  },
});

export const {
  setIsUpdateStatusPopupOpen,
  setSelectedId,
  setPopupType,
  setPreSelectedStatus,
  setOnHoldReason,
  setMaintenanceReport,
  setChangeHistoricalDataSource
} = iShared.actions;
export default iShared.reducer;
